import React from 'react'
import Footer from '../Footer';
import { Link } from 'react-router-dom'
import whatsapp  from '../../assets/images/icons/whatsapp.png'

import embarque from '../../assets/images/desembarque/desembarque-auto.png'
import icon1 from '../../assets/images/icons/documentacion-viajar.png'
import '../../css/listoParaViajar.scss'
import clima from './../../assets/images/recomendacion/viaje.jpg'
import llevar from '../../assets/images/recomendacion/llevar.jpg'

export default function ListoParaViajar() {
    return (
   <section className='listo-viajar'>

                {/* HERO */}
                <div className='listo-viajar-hero'>

                    <div className='overlay'></div>

                    <div className='container hero-content'>

                        <h1> Listo para viajar</h1>

                        <p>
                            Preparamos esta guía para que tu experiencia
                            a bordo sea cómoda, rápida y segura.
                        </p>

                    </div>

                </div>


                {/* ANTES DEL VIAJE */}
                <section className='viaje-section'>

                    <div className='container viaje-grid'>

                        <div className='viaje-content'>

                            <div className='section-header'>

                                <h2>
                                    Antes del viaje
                                </h2>

                                <p>
                                    Viajar en ferri es una experiencia muy agradable
                                    si vas preparado. Aquí tienes tips prácticos
                                    para que tu viaje sea cómodo.
                                </p>

                            </div>


                            <div className='tips-grid'>

                                <div className='tip-card'>

                                    <div className='tip-icon'>
                                        <i className="fi fi-rs-clock-three"></i>
                                    </div>

                                    <div>

                                        <label>
                                            Llega con tiempo
                                        </label>

                                        <p>
                                            Llega con 2 horas previo al zarpe,
                                            ya que deberás pasar revisión y filtros.
                                        </p>

                                    </div>

                                </div>


                                <div className='tip-card'>

                                    <div className='tip-icon'>
                                        <i className="fi fi-rs-clouds-sun"></i>
                                    </div>

                                    <div>

                                        <label>
                                            Revisa el clima
                                        </label>

                                        <p>
                                            Prepárate para posibles retrasos
                                            o movimiento del barco.
                                        </p>

                                    </div>

                                </div>


                                <div className='tip-card'>

                                    <div className='tip-icon'>
                                        <i className="fi fi-rs-document"></i>
                                    </div>

                                    <div>

                                        <label>
                                            Documentos a la mano
                                        </label>

                                        <p>
                                            Lleva boleto, identificación oficial
                                            y documentación del vehículo.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>


                        <div className='viaje-image'>
                            <img src={clima} alt='' />
                        </div>

                    </div>

                </section>


                {/* QUE LLEVAR */}
                <section className='viaje-section section-alt'>

                    <div className='container viaje-grid reverse'>

                        <div className='viaje-image'>
                            <img src={llevar} alt='' />
                        </div>


                        <div className='viaje-content'>

                            <div className='section-header'>

                                <h2>
                                    ¿Qué llevar contigo?
                                </h2>

                                <p>
                                    Tips para mejorar tu experiencia a bordo.
                                </p>

                            </div>


                            <div className='tips-grid'>

                                <div className='tip-card'>

                                    <div className='tip-icon'>
                                        <i className="fi fi-rs-shirt"></i>
                                    </div>

                                    <div>

                                        <label>
                                            Ropa cómoda
                                        </label>

                                        <p>
                                            En cubierta puede hacer viento
                                            y dentro suele haber aire acondicionado.
                                        </p>

                                    </div>

                                </div>


                                <div className='tip-card'>

                                    <div className='tip-icon'>
                                        <i className="fi fi-rs-medicine"></i>
                                    </div>

                                    <div>

                                        <label>
                                            Medicamentos contra el mareo
                                        </label>

                                        <p>
                                            Prepárate para posibles movimientos
                                            del barco y viaja tranquilo.
                                        </p>

                                    </div>

                                </div>


                                <div className='tip-card'>

                                    <div className='tip-icon'>
                                        <i className="fi fi-rs-headphones"></i>
                                    </div>

                                    <div>

                                        <label>
                                            Entretenimiento
                                        </label>

                                        <p>
                                            Lleva audífonos, libros o descarga
                                            tus series favoritas antes del viaje.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        

                        </div>

                    </div>

                </section>


                {/* VEHICULO */}
                <section className='vehiculo-wrapper'>

                    <div className='container'>

                        <div className='vehiculo-section'>

                            <div className='vehiculo-image'>
                                <img src={embarque} alt='' />
                            </div>


                            <div className='vehiculo-content'>

                                <h2>
                                    ¿Viajas con vehículo?
                                </h2>

                                <p>
                                    Se considera vehículo aquellos autos de uso
                                    personal o familiar. Tus acompañantes deberán
                                    abordar como pasajeros a pie, excepto niños
                                    o mascotas.
                                </p>

                                <ul>
                                    <li>
                                        <i className="fi fi-rs-clock-three"></i>
                                        Llega al puerto con 2 horas de anticipación.
                                    </li>

                                    <li>
                                        <i className="fi fi-rs-document"></i>
                                        Lleva tu documentación y pedimento si aplica.
                                    </li>

                                    <li>
                                        <i className="fi fi-rs-shield-check"></i>
                                        Pasa revisión de autoridades portuarias.
                                    </li>
                                </ul>
                               
                                <Link to="/viajar-con-auto">
                                    Ver guía completa
                                </Link>

                            </div>

                        </div>

                    </div>

                </section>


                {/* FAQ */}
                {/*}
                <section className='faq-section'>

                    <div className='container'>

                        <div className='faq-header'>

                            <h2>
                                Preguntas frecuentes
                            </h2>

                            <p>
                                Resolvemos las dudas más comunes
                                antes de tu viaje.
                            </p>

                        </div>


                        <div className='faq-list'>

                            <div className='faq-item'>

                                <span>
                                    ¿Cómo llegar al puerto?
                                </span>

                                <i className="fi fi-rs-plus"></i>

                            </div>


                            <div className='faq-item'>

                                <span>
                                    ¿Qué documentos necesito?
                                </span>

                                <i className="fi fi-rs-plus"></i>

                            </div>


                            <div className='faq-item'>

                                <span>
                                    ¿Cuánto tiempo antes debo llegar?
                                </span>

                                <i className="fi fi-rs-plus"></i>

                            </div>

                        </div>

                    </div>

                </section>
                */}


                {/* CTA */}
                <section className='viaje-cta'>

                    <div className='container'>

                        <h2>
                            ¿Todo listo para tu aventura?
                        </h2>

                        <p>
                            Nuestro centro de ayuda está disponible
                            para resolver cualquier duda.
                        </p>

                        <div className='cta-buttons'>

                      
                            <div><a href="https://wa.me/8003377437?text=Necesito%20ayuda" target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp"> <img src={whatsapp} alt='whatsapp baja ferries' /> WhatsApp</a></div>                                 
                         
                        </div>

                    </div>

                </section>

                <Footer />

            </section>
    )
}


